import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import WidgetConfigForm from "./WidgetConfigForm";
import ElementsConfiguration from "./ElementsConfiguration";
import aggregationElements from "./aggregationElementDefinitions";
import VisualizationContainer from "./VisualizationContainer";
const aggregationElementsByKey = Object.fromEntries(aggregationElements.map((element) => [element.key, element]));
const _initialFormValues = (config) => aggregationElements.reduce(
  (formValues, element) => ({
    ...formValues,
    ...element.fromConfig ? element.fromConfig(config) : {}
  }),
  {}
);
const Controls = styled.div`
  height: 100%;
  min-width: 315px;
  max-width: 500px;
  flex: 1.2;
  padding-right: 15px;
`;
const Section = styled.div`
  height: 100%;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const onCreateElement = (elementKey, values, setValues) => {
  var _a;
  const aggregationElement = aggregationElementsByKey[elementKey];
  if (aggregationElement == null ? void 0 : aggregationElement.onCreate) {
    setValues(aggregationElement.onCreate(values));
  } else {
    setValues({
      ...values,
      [elementKey]: [...(_a = values[elementKey]) != null ? _a : [], {}]
    });
  }
};
export const updateWidgetAggregationElements = (formValues, oldConfig = AggregationWidgetConfig.builder().build()) => {
  const toConfigByKey = Object.fromEntries(aggregationElements.map(({ key, toConfig }) => [key, toConfig]));
  const newConfig = Object.keys(formValues).map((key) => {
    var _a;
    const toConfig = (_a = toConfigByKey[key]) != null ? _a : (_values, prevConfig) => prevConfig;
    if (!toConfig) {
      throw new Error(`Aggregation element with key ${key} is missing toConfig.`);
    }
    return toConfig;
  }).reduce((prevConfig, toConfig) => toConfig(formValues, prevConfig), oldConfig.toBuilder());
  return newConfig.build();
};
const _onSubmit = (formValues, onConfigChange, oldConfig) => {
  const newConfig = updateWidgetAggregationElements(formValues, oldConfig);
  return onConfigChange(newConfig);
};
const validateForm = (formValues) => {
  const elementValidations = aggregationElements.map(
    (element) => {
      var _a;
      return (_a = element.validate) != null ? _a : () => ({});
    }
  );
  const elementValidationResults = elementValidations.map((validate) => validate(formValues));
  return elementValidationResults.reduce((prev, cur) => ({ ...prev, ...cur }), {});
};
const AggregationWizard = ({
  onChange,
  config,
  children,
  onCancel
}) => {
  const initialFormValues = useMemo(() => _initialFormValues(config), [config]);
  return /* @__PURE__ */ React.createElement(
    WidgetConfigForm,
    {
      onSubmit: (formValues) => _onSubmit(formValues, onChange, config),
      initialValues: initialFormValues,
      config,
      validate: validateForm
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Controls, null, /* @__PURE__ */ React.createElement(Section, { "data-testid": "configure-elements-section" }, /* @__PURE__ */ React.createElement(
      ElementsConfiguration,
      {
        aggregationElementsByKey,
        config,
        onCreate: onCreateElement,
        onCancel,
        onConfigChange: onChange
      }
    ))), /* @__PURE__ */ React.createElement(VisualizationContainer, null, children))
  );
};
export default AggregationWizard;
